import { Box, Typography } from '@mui/material';
import { useTheme } from '@mui/material/styles';

import { SolidButton } from 'components/buttons/SolidButton';
import { OutlineButton } from 'components/buttons/OutlineButton';

import ModalContainer from 'components/ModalContainer';

export default function CreateNewProfileModal({ profileType, openModal, setOpenModal, onClickLeaveNowBtn }) {
  const theme = useTheme();

  return (
    <ModalContainer display={openModal} modalWidth="550px">
      <Box sx={{ textAlign: 'center' }}>
        <Typography
          sx={{
            color: theme.palette.primary.main,
            fontFamily: theme.typography.fontFamily,
            fontWeight: theme.typography.customFontWeight[3],
            fontSize: theme.typography.customFontSize[5],
          }}
        >
          Create New {profileType}
        </Typography>

        <Box
          sx={{
            display: 'flex',
            justifyContent: 'center',
            marginTop: '20px',
          }}
        >
          <Typography
            sx={{
              color: theme.palette.primary.black,
              fontSize: theme.typography.customFontSize[3],
              fontFamily: theme.typography.fontFamily,
              fontWeight: theme.typography.customFontWeight[0],
              whiteSpace: 'pre-wrap',
            }}
          >
            Are you sure you want to abandon edit and go to profile settings?
          </Typography>
        </Box>

        <Box
          sx={{
            paddingTop: '20px',
            display: 'flex',
            justifyContent: 'center',
          }}
        >
          <OutlineButton onClick={() => setOpenModal(false)} sx={{ marginRight: '20px' }} width="100px" height="32px">
            Cancel
          </OutlineButton>
          <SolidButton
            onClick={onClickLeaveNowBtn}
            width="100px"
            height="32px"
          >
            Leave Now
          </SolidButton>
        </Box>
      </Box>
    </ModalContainer>
  );
}
